import type { Centavos } from '@laser/core';

const mxn0 = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0, minimumFractionDigits: 0 });
const mxn2 = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2, maximumFractionDigits: 2 });
const num = new Intl.NumberFormat('es-MX', { maximumFractionDigits: 1 });
const pct0 = new Intl.NumberFormat('es-MX', { style: 'percent', maximumFractionDigits: 0 });

/** Centavos → "$1,234". Si hay centavos sueltos y `exacto`, "$12.50". */
export function pesos(c: Centavos | null | undefined, exacto = false): string {
  if (c == null || !Number.isFinite(c)) return '—';
  if (exacto && c % 100 !== 0) return mxn2.format(c / 100);
  return mxn0.format(Math.round(c / 100));
}

/** Texto que escribió el admin ("1,234.50", "$ 99") → centavos. Vacío → null. */
export function centavosDesdeTexto(t: string): Centavos | null {
  const limpio = t.replace(/[^0-9.,-]/g, '').replace(/,/g, '');
  if (limpio === '' || limpio === '-' || limpio === '.') return null;
  const n = Number(limpio);
  return Number.isFinite(n) ? Math.round(n * 100) : null;
}

/** Centavos → valor para un input de pesos ("1234.5"). */
export function textoDesdeCentavos(c: Centavos | null | undefined): string {
  if (c == null) return '';
  return String(c / 100);
}

export const numero = (n: number) => num.format(n);
export const porcentaje = (f: number) => pct0.format(f);

/** Segundos → "45 s", "12 min", "1 h 05 min". */
export function duracion(segundos: number | null | undefined): string {
  if (segundos == null || !Number.isFinite(segundos)) return '—';
  const s = Math.max(0, Math.round(segundos));
  if (s < 60) return `${s} s`;
  const min = Math.round(s / 60);
  if (min < 60) return `${min} min`;
  const h = Math.floor(min / 60);
  return `${h} h ${String(min % 60).padStart(2, '0')} min`;
}

/** Minutos (con decimales) → "12 min" / "1 h 05 min". */
export const minutos = (m: number | null | undefined) => (m == null ? '—' : duracion(m * 60));

/** Cronómetro: segundos → "1:02:03" o "02:03". */
export function cronometro(segundos: number): string {
  const s = Math.max(0, Math.floor(segundos));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const r = s % 60;
  const mm = String(m).padStart(2, '0');
  const ss = String(r).padStart(2, '0');
  return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}

/** "600 × 400 mm" */
export const medidas = (a: number, b: number) => `${numero(a)} × ${numero(b)} mm`;

/** Diferencia relativa final vs original: +0.12 = 12% más caro. */
export function diferenciaRelativa(original: number, final: number): number {
  if (!original) return 0;
  return (final - original) / original;
}

export function signoPct(f: number): string {
  const t = pct0.format(Math.abs(f));
  if (Math.round(f * 100) === 0) return '0%';
  return (f > 0 ? '+' : '−') + t;
}
